module.exports = __webpack_public_path__ + "img/title.9b21c31e.png";